import Controller from '../abstracts/Controller';

export default class VoidController extends Controller {
  static get COMPONENTS() {
    return [
    ];
  }

  init() {
    super.init();
  }

}
